import { render, staticRenderFns } from "./LabelAfterCheckbox.vue?vue&type=template&id=d88270d6&scoped=true"
import script from "./LabelAfterCheckbox.vue?vue&type=script&lang=ts"
export * from "./LabelAfterCheckbox.vue?vue&type=script&lang=ts"
import style0 from "./LabelAfterCheckbox.vue?vue&type=style&index=0&id=d88270d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88270d6",
  null
  
)

export default component.exports